<div class="analytics-page">
  <div class="analytics-header">
    <h2 class="mat-h2">Analytics</h2>
    <p class="page-description">Download reports and analyze data from your system</p>
  </div>

  <div class="analytics-content">
    <div class="analytics-section">
      <app-kpi-export></app-kpi-export>
    </div>

    <!-- Future analytics components can be added here -->
  </div>
</div>
